import {
  Col,
  Divider,
  Row,
  Form,
  Input,
  message,
  Upload,
  Select,
  DatePicker,
} from "antd";
import { FaArrowLeftLong } from "react-icons/fa6";
import { BsCameraFill } from "react-icons/bs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PROFILE, UPLOADS_URL } from "../../config/constants/api";
import { Put } from "../../config/api/put";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";
import { addUser } from "../../redux/slice/authSlice";
import dayjs from "dayjs";
import moment from "moment";
import { ImageUrl } from "../../config/helper";



const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
};
const beforeUpload = (file) => {
  const isImage = file.type.startsWith("image/");
  if (!isImage) {
    message.error("Invalid Uplaod, You can only upload image files!");
  }
  return isImage;
};

const EditProfile = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [imageObject, setImageObject] = useState(null);
  const navigate = useNavigate();
  const [imageUrl, setImageUrl] = useState("");
  const [form] = Form.useForm();
  const userData = useSelector((state) => state.user.userData);
  const token = useSelector((state) => state.user.userToken);
  useEffect(() => {
    form.setFieldsValue({
      firstName: userData?.firstName,
      lastName: userData?.lastName,
      email: userData?.email,
      phone: userData?.phone,
      // gender: userData?.gender,
      // dateOfBirth: dayjs(userData?.dateOfBirth),
    });
  }, []);
  const onFinish = (values) => {
    const { firstName, lastName, phone, gender, dateOfBirth } = values;
    const formValuesChanged = () => {
      return (
        userData?.firstName !== firstName ||
        userData?.lastName !== lastName ||
        userData?.phone !== phone ||
        // userData?.gender !== gender ||
        // !dayjs(userData?.dateOfBirth).isSame(dateOfBirth) ||
        imageObject
      );
    };
    if (formValuesChanged()) {
      let data = new FormData();
      data.append("image", imageObject);
      data.append("firstName", firstName);
      data.append("lastName", lastName);
      data.append("phone", phone);
      // data.append("gender", gender);
      // data.append("dateOfBirth", moment(dateOfBirth?.$d).format("YYYY-MM-DD"));
      Put(PROFILE.updateMyProfile, token, data, {}, "multipart")
        .then((response) => {
          if (response.status) {
            dispatch(addUser({ user: response?.data, token: token }));
            form.resetFields();
            swal("Success", response?.message, "success");
            navigate("/profile");
          }
        })
        .catch((err) => {
          console.log("Error", err);
          swal("Error", err?.response?.data?.message, "error");
        });
    } else {
      swal("System Alert", "No Changes Detected", "error");
      return;
    }
  };
  const handleChangepro = (info) => {
    setLoading(true);
    getBase64(
      info?.fileList[info?.fileList?.length - 1]?.originFileObj,
      (url) => {
        setImageObject(
          info?.fileList[info?.fileList?.length - 1]?.originFileObj
        );
        setLoading(false);
        setImageUrl(url);
      }
    );
  };
  let initialUrl = UPLOADS_URL + userData?.image 

  return (
    <Row justify="center" className="py-16 max-sm:py-8 bg-white">
      <Col md={12} sm={22} xs={22}>
      <FaArrowLeftLong
                          className="arrow cursor-pointer"
                          onClick={() => navigate(-1)}
                        />
        <Row justify="center">
          <h3 className="font-tavi text-3xl text-black max-sm:text-xl font-semibold">
            Edit Profile
          </h3>
        </Row>
        <Row justify="center" className="mb-12">
          <Col xxl={10} xl={14} md={18} sm={24} xs={24}>
            <div className="flex flex-col justify-center items-center mt-6 bg-white py-8 px-6 rounded-lg shadow-lg">
              {imageUrl ? (
                <img
                  src={imageUrl}
                  alt="avatar"
                  style={{
                    height: "100px",
                    width: "100px",
                    borderRadius: "100%",
                    objectFit: "cover",
                    objectPosition: "center",
                  }}
                />
              ) : (
                <img
                   src={(!initialUrl || initialUrl.includes('null')) ? ImageUrl('avatar.png') : initialUrl}
                  editProfile
                  alt="profile"
                  style={{
                    height: "100px",
                    width: "100px",
                    borderRadius: "100%",
                    objectFit: "cover",
                    objectPosition: "center",
                  }}
                />
              )}
              <div className="flex justify-center items-center p-2 bg-customGold rounded-full mt-[-20px] ml-[50px] cursor-pointer">
                {/* <BsCameraFill size={16} className="text-white" /> */}
                <Upload
                  name="image"
                  showUploadList={false}
                  style={{ position: "relative" }}
                  onChange={handleChangepro}
                  beforeUpload={beforeUpload}
                >
                  <BsCameraFill size={16} className="text-white" />
                </Upload>
              </div>
              <h5 className="my-2 text-center font-euclid text-sm font-semibold text-customBlack">
                {userData?.firstName} {userData?.lastName}
              </h5>
              {/* <Divider />
              <div className="flex justify-center items-center mt-3">
                <p className="font-euclid text-sm font-bold text-customBlack text-center px-8 max-sm:px-4 border-r border-gray-200">
                  50+ <br />
                  <span className="text-xs font-semibold">Rides</span>
                </p>
                <div className="font-euclid text-sm font-bold text-customBlack text-center px-8 max-sm:px-4 border-r border-gray-200 flex flex-col justify-center items-center">
                  <div className="flex justify-center">
                    <FaStar className="mr-1 text-customGold" /> 5.0
                  </div>
                  <span className="text-xs font-semibold">Rating</span>
                </div>
                <p className="font-euclid text-sm font-bold text-customBlack text-center px-8 max-sm:px-4 ">
                  4.2 <br />
                  <span className="text-xs font-semibold">Years</span>
                </p>
              </div> */}
            </div>
          </Col>
        </Row>
        <Divider />
        <Form
          form={form}
          name="normal_login"
          onFinish={onFinish}
          layout="vertical"
          className="w-full px-8 max-xl:px-2"
        >
          <Row justify="center" className="mt-12">
            <h5 className="font-tavi text-2xl text-black mb-8 max-sm:text-lg font-semibold">
              Personal Profile
            </h5>
            <div className="bg-white px-8 rounded-lg shadow-lg w-full py-4">
              <Row gutter={[16, 16]}>
                <Col lg={12} md={12} xs={24}>
                  <Form.Item
                    name="firstName"
                    label={
                      <p className="font-euclid text-sm text-[#34324B] font-bold">
                        First Name
                      </p>
                    }
                  >
                    <Input
                      placeholder="First Name"
                      className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
                      autoComplete={false}
                    />
                  </Form.Item>
                </Col>
                <Col lg={12} md={12} xs={24}>
                  <Form.Item
                    name="lastName"
                    label={
                      <p className="font-euclid text-sm text-[#34324B] font-bold">
                        Last Name
                      </p>
                    }
                  >
                    <Input
                      placeholder="Last Name"
                      className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
                      autoComplete={false}
                    />
                  </Form.Item>
                </Col>
                <Col lg={12} md={12} xs={24}>
                  <Form.Item
                    name="email"
                    label={
                      <p className="font-euclid text-sm text-[#34324B] font-bold">
                        Email Address
                      </p>
                    }
                  >
                    <Input
                      disabled
                      placeholder="Email Address"
                      className="h-12 text-sm font-euclid max-sm:text-xs"
                      autoComplete={false}
                      style={{ backgroundColor: "#48465c", color: "#fff" }}
                    />
                  </Form.Item>
                </Col>
                <Col lg={12} md={12} xs={24}>
                  <Form.Item
                    name="phone"
                    label={
                      <p className="font-euclid text-sm text-[#34324B] font-bold">
                        Phone Number
                      </p>
                    }
                  >
                    <Input
                      placeholder="Last Name"
                      className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
                      autoComplete={false}
                    />
                  </Form.Item>
                </Col>
                {/* <Col lg={12} md={12} xs={24}>
                  <Form.Item
                    label={
                      <p className="font-euclid text-sm text-[#34324B] font-bold">
                        Gender
                      </p>
                    }
                    name="gender"
                  >
                    <Select
                      placeholder="Select"
                      className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
                    >
                      <Select.Option value="MALE">Male</Select.Option>
                      <Select.Option value="FEMALE">Female</Select.Option>
                      <Select.Option value="OTHERS">Others</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>

                <Col lg={12} md={12} xs={24}>
                  <Form.Item
                    label={
                      <p className="font-euclid text-sm text-[#34324B] font-bold">
                        Date Of Birth
                      </p>
                    }
                    name="dateOfBirth"
                  >
                    <DatePicker className="h-12 w-full text-sm font-euclid bg-gray-100 max-sm:text-xs" />
                  </Form.Item>
                </Col> */}
              </Row>
            </div>
          </Row>
          <div className="flex justify-center">
            <button
              htmlType="submit"
              className="uppercase bg-button px-4 py-4 text-white rounded-lg text-sm font-bold max-sm:text-xs max-md:px-4 mt-6"
            >
              Update Profile
            </button>
          </div>
          {/* <Divider />
          <Row justify="center" className="mt-12">
            <h5 className="font-tavi text-2xl text-black mb-8 max-sm:text-lg font-semibold">
              Business Profile
            </h5>
            <div className="bg-white px-8 rounded-lg shadow-lg w-full">
              <Row gutter={[16, 16]}>
                <Col lg={12} md={12} xs={24}>
                  <Form.Item
                    name="businessName"
                    label={
                      <p className="font-euclid text-sm text-[#34324B] font-bold">
                        Business Name
                      </p>
                    }
                  >
                    <Input
                      placeholder="Business Name"
                      className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs "
                      autoComplete={false}
                    />
                  </Form.Item>
                </Col>

                <Col lg={12} md={12} xs={24}>
                  <Form.Item
                    name="businessEmail"
                    label={
                      <p className="font-euclid text-sm text-[#34324B] font-bold">
                        Business Email
                      </p>
                    }
                  >
                    <Input
                      disabled={userData?.businessProfile?.businessEmail}
                      placeholder="Business Email"
                      className="h-12 text-sm font-euclid max-sm:text-xs"
                      autoComplete={false}
                      type="email"
                      style={
                        userData?.businessProfile?.businessEmail
                          ? { backgroundColor: "#48465c", color: "#fff" }
                          : {}
                      }
                    />
                  </Form.Item>
                </Col>
                <Col lg={12} md={12} xs={24}>
                  <Form.Item
                    name="businessPhone"
                    label={
                      <p className="font-euclid text-sm text-[#34324B] font-bold">
                        Business Phone Number
                      </p>
                    }
                  >
                    <Input
                      placeholder="Business Phone Number"
                      className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
                      autoComplete={false}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </div>
            <Form.Item>
           
            </Form.Item>
          </Row> */}
        </Form>
      </Col>
    </Row>
  );
};

export default EditProfile;
